module.exports = __webpack_public_path__ + "static/media/gc.7f547c3c.png";